import { render, staticRenderFns } from "./SanPhamTieuBieu.vue?vue&type=template&id=c40d11a0&scoped=true&"
import script from "./SanPhamTieuBieu.vue?vue&type=script&lang=js&"
export * from "./SanPhamTieuBieu.vue?vue&type=script&lang=js&"
import style0 from "./SanPhamTieuBieu.vue?vue&type=style&index=0&id=c40d11a0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c40d11a0",
  null
  
)

export default component.exports